import { render } from "./ReceivePremium.vue?vue&type=template&id=5a9f4e92&scoped=true"
import script from "./ReceivePremium.vue?vue&type=script&lang=js"
export * from "./ReceivePremium.vue?vue&type=script&lang=js"

import "./ReceivePremium.vue?vue&type=style&index=0&id=5a9f4e92&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a9f4e92"]])

export default __exports__